import classNames from 'classnames';
import React from 'react';
import { LegacyIconRenderer } from "../../../../helper/components/LegacyIconRenderer.js";
import styles from "./DataGridContextMenuItem.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function DataGridContextMenuItem(props) {
  function onItemClick() {
    if (props.onClick) {
      props.onClick();
    }
    if (props.closeOnItemClick) {
      props.closeOnItemClick();
    }
  }
  return /*#__PURE__*/_jsxs("li", {
    className: classNames(styles.menuItem, props.disabled && styles.disabled),
    onClick: () => onItemClick(),
    children: [/*#__PURE__*/_jsx(LegacyIconRenderer, {
      icon: props.icon,
      size: "SMALL"
    }), props.text]
  });
}